import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  Progress,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  CardText,
} from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Table,
  FormGroup,
  Form,
  Input,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import creditMappingModel from "models/creditMapping.model";
import classnames from "classnames";
import BasicDetails from "./parentsprofile/BasicDetails";
import StudentDemo from "./parentsprofile/StudentDemo";
import Classes from "./parentsprofile/Classes";
import Payments from "./parentsprofile/Payments";
import parentsModal from "models/parents.modal";
import { helper } from "lib/helper";
import { FaPhone, FaHome, FaUser, FaPlus } from "react-icons/fa";
import Commenction from "./parentsprofile/Commenction";
import axios from "axios";
import Swal from "sweetalert2";
import enquiriesModal from "models/enquiries.modal";
import moment from "moment";
import Parentmodel from "models/parents.modal";
import { toast } from "lib/helper";
// import { RiDeleteBin5Line } from "react-icons/ri";
import AttendanceModel from "models/Attendance.modal";
import Finanacemanagement from "models/financemanagement.modal";
import SupportTickets from "models/supportticket.modal";

const ParentsProfile = () => {
  const [activeTab, setActiveTab] = useState("Basicdetails");
  const [allStudentget, setAllStudentGet] = useState();
  const [showAll, setShowAll] = useState(false);
  const [data, setData] = useState();
  const [leaveon, setLeaveon] = useState(false);
  const Navigate = useNavigate();

  const toggleNotes = () => setShowAll((prev) => !prev);
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  const getTabContentStyle = (tabId) => {
    return {
      display: activeTab === tabId ? "block" : "none",
      transition: "height 0.3s ease-in-out",
      overflow: "hidden",
    };
  };
  const [allAttendance, setSllAttendance] = useState();
  const [dataList, setDataList] = useState([]);
  const location = useLocation();
  const params = useParams();

  const toggle6 = () => {
    setLeaveon(!leaveon);
  };
  const invoicelist = async () => {
    // Dummy data for testing
    const dummyInvoices = [
      {
        id: 1,
        updatedAt: "2023-10-01T10:00:00Z",
        invoice_number: "INV-001",
        invoicePic: {
          image: "https://via.placeholder.com/50x50?text=Invoice",
        },
        invoice_amount: 5000,
      },
      {
        id: 2,
        updatedAt: "2023-10-15T14:30:00Z",
        invoice_number: "INV-002",
        invoicePic: {
          image: "https://via.placeholder.com/50x50?text=Invoice",
        },
        invoice_amount: 3000,
      },
      {
        id: 3,
        updatedAt: "2023-11-01T09:15:00Z",
        invoice_number: "INV-003",
        invoicePic: {
          image: "https://via.placeholder.com/50x50?text=Invoice",
        },
        invoice_amount: 4500,
      },
    ];
    setData(dummyInvoices);
    // Finanacemanagement.invoicelistbyid(dataList?.user?.id)
    //   .then((responce) => {
    //     setData(responce?.data?.data);
    //   })
    //   .catch((error) => {
    //     console.log("error", error);
    //   });
  };

  useEffect(() => {
    invoicelist();
  }, [dataList]);

  const getListData = async () => {
    // setIsLoading(true);
    // Dummy data for testing
    const dummyData = {
      user: {
        first_name: "John",
        last_name: "Doe",
        mobile: "1234567890",
        email: "john.doe@example.com",
      },
      students: [
        {
          id: 1,
          name: "Alice Doe",
          gender: "Female",
          dob: "2008-05-15",
          school_name: "Sample High School",
          preferrd_time: "2 hours",
          term: "1 year",
          location: "New York",
          tutor_level: "Intermediate",
        },
        {
          id: 2,
          name: "Bob Doe",
          gender: "Male",
          dob: "2010-03-22",
          school_name: "Another School",
          preferrd_time: "1.5 hours",
          term: "6 months",
          location: "California",
          tutor_level: "Beginner",
        },
        {
          id: 3,
          name: "Charlie Doe",
          gender: "Male",
          dob: "2006-11-10",
          school_name: "High School University",
          preferrd_time: "3 hours",
          term: "2 years",
          location: "Texas",
          tutor_level: "Advanced",
        },
      ],
      tutor_classes: [
        {
          id: 1,
          name: "Math Class",
          mode: "Online",
          state: "California",
          city: "Los Angeles",
          location: "Virtual",
          badge: "Active",
          start_date: "2023-09-01",
          start_time: "10:00 AM",
          end_time: "11:00 AM",
          tutor: {
            user: {
              first_name: "Jane",
              last_name: "Smith",
            },
          },
        },
        {
          id: 2,
          name: "Science Class",
          mode: "Offline",
          state: "New York",
          city: "New York City",
          location: "School Campus",
          badge: "Active",
          start_date: "2023-09-02",
          start_time: "02:00 PM",
          end_time: "03:00 PM",
          tutor: {
            user: {
              first_name: "Bob",
              last_name: "Johnson",
            },
          },
        },
      ],
    };
    setDataList(dummyData);
    // await parentsModal
    //   .listbyParentid(params?.id)
    //   .then((result) => {
    //     // setIsLoading(false);
    //     if (result) {
    //       setDataList(result?.data?.data);
    //     }
    //   })
    //   .catch((error) => {
    //     // helper.sweetalert.toast(error?.response?.data?.message, "warning");
    //   });
  };

  useEffect(() => {
    getListDataAllStudent();
    getListData();
  }, [location, params?.id]);
  useEffect(() => {
    GetAllAttendance();
    GetClassDataByid();
    getcreditmapdata();
  }, [dataList]);

  const GetAllAttendance = async () => {
    // Dummy data for testing
    const dummyAttendance = [
      {
        id: 1,
        attendance_date: "2023-10-01",
      },
      {
        id: 2,
        attendance_date: "2023-10-02",
      },
      {
        id: 3,
        attendance_date: "2023-10-03",
      },
      {
        id: 4,
        attendance_date: "2023-10-04",
      },
      {
        id: 5,
        attendance_date: "2023-10-05",
      },
    ];
    setSllAttendance(dummyAttendance);
    // await AttendanceModel.GetAllAttendanceLists(
    //   dataList?.tutor_classes?.[0]?.id
    // )
    //   .then((result) => {
    //     if (result) {
    //       setSllAttendance(result?.data?.data);
    //     }
    //   })
    //   .catch((error) => {
    //     // helper.sweetalert.toast(error.response?.data?.message, "warning");
    //   });
  };

  const [classData, setClassData] = useState([]); // Rename to avoid conflict
  const [sessionPercentage, setSessionPercentage] = useState(0);
  const [remainingSession, setRemainingSession] = useState(0); // Fixed typo in 'remaining'
  const [futureDate, setFutureDate] = useState("");

  const GetClassDataByid = async () => {
    // Dummy data for testing
    const dummyClassData = {
      id: 1,
      name: "Math Class",
      mode: "Online",
      state: "California",
      city: "Los Angeles",
      location: "Virtual",
      badge: "Active",
      start_date: "2023-09-01",
      start_time: "10:00 AM",
      end_time: "11:00 AM",
      number_of_session: 20,
      totalSession: 15,
      price_parent: 5000,
    };
    setClassData(dummyClassData);
    // Calculate remaining sessions and percentage
    let totalSession = dummyClassData.number_of_session;
    let sessionCount = dummyClassData.totalSession;
    let remainingSessions = 0;
    let percent = 0;

    if (totalSession > sessionCount) {
      remainingSessions = totalSession - sessionCount;
      percent = Math.floor((sessionCount / totalSession) * 100);

      if (remainingSessions > 0) {
        const currentDate = new Date();
        const futureDateObj = new Date();
        futureDateObj.setDate(currentDate.getDate() + remainingSessions);
        const formattedDate = futureDateObj.toISOString().split("T")[0];
        setFutureDate(formattedDate);
      }
    } else {
      percent = 100;
    }

    setRemainingSession(remainingSessions);
    setSessionPercentage(percent);
    // await AttendanceModel.GetClassById(dataList?.tutor_classes?.[0]?.id)
    //   .then((result) => {
    //     if (result) {
    //       setClassData(result?.data?.data);
    //       console.log("class result", result);
    //       console.log(result.data);
    //       let totalSession = result?.data?.data?.number_of_session;
    //       let sessionCount = result?.data?.data?.totalSession;
    //       let remainingSessions = 0;
    //       let percent = 0;

    //       if (totalSession > sessionCount) {
    //         remainingSessions = totalSession - sessionCount;
    //         percent = Math.floor((sessionCount / totalSession) * 100);

    //         if (remainingSessions > 0) {
    //           const currentDate = new Date();
    //           const futureDateObj = new Date();
    //           futureDateObj.setDate(currentDate.getDate() + remainingSessions);
    //           const formattedDate = futureDateObj.toISOString().split("T")[0];
    //           setFutureDate(formattedDate);
    //         }
    //       } else {
    //         percent = 100;
    //       }

    //       setRemainingSession(remainingSessions);
    //       setSessionPercentage(percent);
    //       console.log("percent = ", percent);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(error); // Log the error for debugging
    //   });
  };
  console.log("assigntutor", allAttendance);
  const [activeTabsub, setActiveTabSub] = useState("1");

  const toggleSub = (tab) => {
    if (activeTabsub !== tab) setActiveTabSub(tab);
  };

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [NotesList, setNotesList] = useState([]);
  const fetchNotes = async () => {
    // Dummy data for testing
    const dummyNotes = {
      data: [
        {
          id: 1,
          Notes:
            "This is a sample note for the parent. Please review the student's progress.",
          auth_user: {
            first_name: "Admin",
            last_name: "User",
          },
          updatedAt: "2023-10-01T10:00:00Z",
        },
        {
          id: 2,
          Notes: "Reminder: Parent-teacher meeting scheduled for next week.",
          auth_user: {
            first_name: "Jane",
            last_name: "Smith",
          },
          updatedAt: "2023-10-02T14:30:00Z",
        },
        {
          id: 3,
          Notes:
            "Student has shown improvement in math. Keep up the good work!",
          auth_user: {
            first_name: "Bob",
            last_name: "Johnson",
          },
          updatedAt: "2023-10-03T09:15:00Z",
        },
      ],
    };
    setNotesList(dummyNotes);
    // try {
    //   const response = await Parentmodel.getParentnote(
    //     params.id,
    //     "&type=notes"
    //   );
    //   setNotesList(response.data);
    // } catch (error) {
    //   console.log("error", error);
    // }
  };
  const [complainlist, setComplainList] = useState();
  const fetchComplain = async () => {
    try {
      const response = await Parentmodel.getParentnote(
        params.id,
        "&type=complaint"
      );
      setComplainList(response.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const [leavedata, setLeavedata] = useState();
  const fetchLeave = async () => {
    // Dummy data for testing
    const dummyLeaveData = [
      {
        id: 1,
        date: "2023-10-01",
        Notes: "Family vacation planned for this date",
        updatedAt: "2023-09-25T10:00:00Z",
      },
      {
        id: 2,
        date: "2023-10-15",
        Notes: "Medical appointment for the student",
        updatedAt: "2023-10-10T14:30:00Z",
      },
      {
        id: 3,
        date: "2023-11-05",
        Notes: "Diwali holiday celebration",
        updatedAt: "2023-10-20T09:15:00Z",
      },
    ];
    setLeavedata(dummyLeaveData);
    // try {
    //   const response = await Parentmodel.getParentnote(
    //     params.id,
    //     "&type=leave"
    //   );
    //   setLeavedata(response?.data?.data);
    // } catch (error) {
    //   console.log("error", error);
    // }
  };
  useEffect(() => {
    if (params.id != "") {
      fetchNotes();
      fetchComplain();
      fetchLeave();
    }
  }, []);

  const [Notes, setNotes] = useState();
  console.log("dddd-leavedat", leavedata);
  const handleSubmitNotes = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    form.append("ParentId", params.id);
    form.append("type", "notes");
    try {
      const list = await Parentmodel.AddParentnote(form);

      toast("ADDED Note", "success");
      fetchNotes();
      toggle();
    } catch (error) {
      Swal.fire("Error", "There was a problem to add notes", "error");
    } finally {
    }
  };
  const handleSubmitLeave = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    form.append("ParentId", params.id);
    form.append("type", "leave");
    try {
      const list = await Parentmodel.AddParentnote(form);

      toast("ADDED Leave/Holyday", "success");
      fetchLeave();
      toggle6();
    } catch (error) {
      Swal.fire("Error", "There was a problem to add notes", "error");
    } finally {
    }
  };

  const handleDelNotes = async (delId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Parentmodel.deleteParentnote(delId)
          .then((res) => {
            Swal.fire("Deleted!", "The item has been deleted.", "success");
            fetchNotes();
          })
          .catch((error) => {
            console.error("Error deleting product:", error);
          });
      }
    });
  };
  const getListDataAllStudent = async () => {
    await enquiriesModal
      .parentStudentget(337)
      .then((result) => {
        if (result) {
          setAllStudentGet(result.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  const [supportdata, setSupportdata] = useState();
  const tokendeatail = () => {
    // Dummy data for testing
    const dummySupportData = [
      {
        id: 1,
        subject: "Technical Issue with Login",
        complaint: "Unable to access the student portal due to login problems",
        status: "Open",
        updatedAt: "2023-10-01T10:00:00Z",
      },
      {
        id: 2,
        subject: "Class Schedule Change Request",
        complaint: "Request to change the timing of math classes",
        status: "In Progress",
        updatedAt: "2023-10-02T14:30:00Z",
      },
      {
        id: 3,
        subject: "Payment Refund Query",
        complaint: "Inquiry about refund for cancelled sessions",
        status: "Resolved",
        updatedAt: "2023-10-03T09:15:00Z",
      },
    ];
    setSupportdata(dummySupportData);
    // SupportTickets.listsid(dataList?.mobile)
    //   .then((res) => {
    //     setSupportdata(res?.data?.data);
    //   })
    //   .catch((error) => {
    //     console.log("error", error);
    //   });
  };
  useEffect(() => {
    tokendeatail();
  }, [dataList]);

  const [creditdata, setCreditdata] = useState();
  const getcreditmapdata = () => {
    creditMappingModel
      .Detail(dataList?.tutor_classes?.[0]?.id)
      .then((responce) => {
        setCreditdata(responce);
      })
      .catch((error) => {});
  };
  console.log("data class", dataList);
  return (
    <Container className="px-4 py-7">
      <Row>
        <div className="col"></div>
      </Row>
      <Card className="shadow">
        <CardHeader
          CardHeader
          className="border-0 d-flex flex-column flex-md-row justify-content-between align-items-center"
        ></CardHeader>
        <CardBody>
          <div className="container ">
            <div className="row">
              <div className="col-md-12 px-2.5">
                <div
                  className="nav nav-pills flex-column flex-md-row"
                  id="v-pills-tab"
                  role="tablist"
                  style={{ width: "100%" }}
                >
                  <button
                    className={`col-md-2 nav-link ${
                      activeTab === "Basicdetails" ? "active" : ""
                    }`}
                    id="v-pills-home-tab"
                    onClick={() => handleTabClick("Basicdetails")}
                    type="button"
                    role="tab"
                    aria-controls="Basicdetails"
                    aria-selected={activeTab === "Basicdetails"}
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "50px",
                      borderRadius: "0",
                      borderTop: "none",
                      border: "1px solid gray",
                      fontSize: "16px",
                    }}
                  >
                    Profile
                  </button>

                  <button
                    className={`col-md-2 nav-link ${
                      activeTab === "StudentDemo" ? "active" : ""
                    }`}
                    id="v-pills-profile-tab"
                    onClick={() => handleTabClick("StudentDemo")}
                    type="button"
                    role="tab"
                    aria-controls="StudentDemo"
                    aria-selected={activeTab === "StudentDemo"}
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "50px",
                      borderRadius: "0",
                      borderTop: "none",
                      border: "1px solid gray",
                      fontSize: "16px",
                    }}
                  >
                    Activity & Attedance
                  </button>

                  <button
                    className={`col-md-2 nav-link ${
                      activeTab === "Classes" ? "active" : ""
                    }`}
                    id="v-pills-messages-tab"
                    onClick={() => handleTabClick("Classes")}
                    type="button"
                    role="tab"
                    aria-controls="Classes"
                    aria-selected={activeTab === "Classes"}
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "50px",
                      borderRadius: "0",
                      borderTop: "none",
                      border: "1px solid gray",
                      alignItems: "center",
                    }}
                  >
                    Communications
                  </button>

                  <button
                    className={`col-md-2 nav-link ${
                      activeTab === "Payments" ? "active" : ""
                    }`}
                    id="Payments-tab"
                    onClick={() => handleTabClick("Payments")}
                    type="button"
                    role="tab"
                    aria-controls="Payments"
                    aria-selected={activeTab === "Payments"}
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "50px",
                      borderRadius: "0",
                      borderTop: "none",
                      border: "1px solid gray",
                    }}
                  >
                    Class management
                  </button>

                  <button
                    className={`col-md-2 nav-link ${
                      activeTab === "Finance&invoices" ? "active" : ""
                    }`}
                    id="Payments-tab"
                    onClick={() => handleTabClick("Finance&invoices")}
                    type="button"
                    role="tab"
                    aria-controls="Finance&invoices"
                    aria-selected={activeTab === "Finance&invoices"}
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "50px",
                      borderRadius: "0",
                      borderTop: "none",
                      border: "1px solid gray",
                    }}
                  >
                    Finance & invoices
                  </button>
                </div>
              </div>
            </div>

            {/* <div > */}
            <div
              className="col-12  px-0"
              id="v-pills-tabContent"
              style={{
                border: "1px solid gray",
                padding: "20px",
                marginTop: "5px",
              }}
            >
              <div style={getTabContentStyle("Basicdetails")}>
                <CardBody>
                  {/* <BasicDetails  data={dataList}/> */}
                  <Card
                    className="mb-3 w-100"
                    style={{ borderRadius: ".5rem" }}
                  >
                    <Row className="g-0">
                      <Col
                        md="2"
                        className="gradient-custom text-center text-white mt-4 "
                        style={{
                          backgroundColor: "#000f26",
                          height: "120px",
                          width: "100px",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "80px",
                            height: "80px",
                            backgroundColor: "#000f26", // Ensure the same background color is applied
                            borderRadius: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "10px",
                            }}
                            src={`https://cliply.co/wp-content/uploads/2020/09/442008571_ARTIST_AVATAR_3D_400px.gif`}
                            alt="avatar"
                          />
                        </div>
                      </Col>
                      <Col md="10">
                        <CardBody>
                          <Container style={{ border: "1px solid #ccc" }}>
                            <Row>
                              <Col
                                md={8}
                                style={{ borderRight: "1px solid #ccc" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <FaUser className="me-2" />
                                  <span className="ml-1">
                                    Parent -{" "}
                                    {`${dataList?.user?.first_name} ${dataList?.user?.last_name}`}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <FaPhone className="me-2" />
                                  <span className="ml-1">
                                    {dataList?.mobile}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <FaHome className="me-2" />
                                  <span className="ml-1">
                                    {dataList?.location &&
                                      dataList?.location !== "null" && (
                                        <>{dataList?.location} , </>
                                      )}
                                  </span>
                                  <span className="ml-1">
                                    {dataList?.city
                                      ? `${dataList?.city}, `
                                      : ""}
                                  </span>
                                  <span className="ml-1">
                                    {dataList?.state
                                      ? `${dataList?.state} `
                                      : ""}
                                  </span>
                                </div>
                              </Col>
                              <Col md={4}>
                                <div style={{ marginBottom: "10px" }}>
                                  <strong>ID:</strong>{" "}
                                  <span>P-{dataList?.user?.id}</span>
                                </div>
                                <div style={{ marginBottom: "10px" }}>
                                  <strong>Date of Joining:</strong>{" "}
                                  <span>
                                    {moment(dataList?.user?.date_joined).format(
                                      "DD MMM YY"
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                </CardBody>

                <Row>
                  <div className="col">
                    <Card className="shadow">
                      <CardHeader className="border-0 d-flex justify-content-between ">
                        <h3 className="mb-0">Students List</h3>
                      </CardHeader>
                      {dataList?.students?.length > 0 ? (
                        <Table
                          className="align-items-center table-flush"
                          responsive
                        >
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">S.No</th>
                              <th scope="col">Student Name</th>
                              <th scope="col">Gender</th>
                              <th scope="col">Date of Birth</th>
                              <th scope="col">
                                School/College/University Name
                              </th>
                              <th scope="col">Preferred Time Duration</th>
                              <th scope="col">Tuition Tenure</th>
                              <th scope="col"> Loaction</th>
                              <th scope="col"> Tutors Level</th>
                              {/* <th scope="col">Action</th>*/}
                            </tr>
                          </thead>
                          <tbody>
                            {dataList.students.map(
                              (studentData, studentindex) => (
                                <tr key={`${studentindex}student`}>
                                  <td>{studentindex + 1}</td>
                                  <td>{studentData.name}</td>
                                  <td>{studentData.gender}</td>
                                  <td>{studentData.dob}</td>
                                  <td>{studentData.school_name}</td>
                                  <td>{studentData.preferrd_time}</td>
                                  <td>{studentData.term}</td>
                                  <td>{studentData.location}</td>
                                  <td>{studentData.tutor_level}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      ) : (
                        <p className="ml-3">No students added</p>
                      )}
                    </Card>
                  </div>
                </Row>

                <Row className="mt-2">
                  <Col md={6}>
                    {dataList?.tutor_classes && (
                      <Card className="shadow">
                        <CardHeader className="border-0 d-flex justify-content-between ">
                          <h3 className="mb-0">Class Assigned to</h3>
                        </CardHeader>

                        <Table
                          className="align-items-center table-flush"
                          responsive
                        >
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">Tutor Name</th>
                              <th scope="col">Class NAME</th>
                            </tr>
                          </thead>

                          <tbody>
                            {dataList?.tutor_classes?.map(
                              (classList, classIndex) => (
                                <tr
                                  style={{ cursor: "pointer" }}
                                  key={`${classIndex}classes`}
                                >
                                  <td>
                                    {" "}
                                    {classList?.tutor?.user?.first_name}{" "}
                                  </td>
                                  <td> {classList?.name} </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </Card>
                    )}
                  </Col>
                  <Col md={6}>
                    <Card style={{ border: "1px solid #ccc" }}>
                      <CardBody>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <CardTitle tag="h3" style={{ marginBottom: "20px" }}>
                            Note
                          </CardTitle>
                          <Button color="primary" size="sm" onClick={toggle}>
                            <FaPlus /> Add
                          </Button>
                        </div>
                        {NotesList?.data
                          ?.slice(0, showAll ? NotesList.data.length : 1) // Show all or just one
                          .map((item, index) => (
                            <div className="border p-2 mb-2" key={index}>
                              <CardText>{item?.Notes}</CardText>
                              <CardText>
                                <small className="text-muted">
                                  Written by {item?.auth_user?.first_name}{" "}
                                  {item?.auth_user?.last_name}
                                </small>
                              </CardText>
                              <CardText className=" d-flex justify-content-between">
                                {moment(item?.updatedAt).format(
                                  "DD/MM/YYYY HH:mm A"
                                )}
                                <div
                                  className="cursor-pointer"
                                  onClick={() => {
                                    handleDelNotes(item?.id);
                                  }}
                                >
                                  {/* <RiDeleteBin5Line className="text-red" /> */}
                                </div>
                              </CardText>
                            </div>
                          ))}

                        <a
                          href="#"
                          className="text-primary"
                          onClick={toggleNotes}
                        >
                          {showAll ? "Show Less Notes" : "Show All Notes"}
                        </a>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>

              <div style={getTabContentStyle("StudentDemo")}>
                <Row>
                  <Col mb="4" className="d-flex align-items-center ">
                    <h3>Class</h3>

                    {/* <Button
                      className="ml-2"
                      to="/admin/classes/addclasss"
                      onClick={() => {
                        Navigate(
                          `/admin/classes/addclasss/${dataList?.mobile}/${dataList?.tutor_classes?.[0]?.name}`
                        );
                      }}
                    >
                      Create Class
                    </Button>*/}
                  </Col>
                  <Col md="6" className="text-right">
                    <div>Total hours taught: 44 hours</div>
                    <div>Total hours taught: 32 hours</div>
                  </Col>
                </Row>

                <Card className="shadow">
                  <CardHeader className="border-0 d-flex justify-content-between ">
                    <h3 className="mb-0">Students List</h3>
                  </CardHeader>
                  {dataList?.students?.length > 0 ? (
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">S.No.</th>
                          <th scope="col">Student NAME</th>
                          <th scope="col">Gender</th>
                          <th scope="col">Date of Birth</th>
                          <th scope="col">School/College/University Name</th>
                          <th scope="col">Preferred Time Duration</th>
                          <th scope="col">Tuition Tenure</th>
                          <th scope="col"> Loaction</th>
                          <th scope="col"> Tutors Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataList.students.map((studentData, studentindex) => (
                          <tr key={`${studentindex}student`}>
                            <td>{studentindex + 1}</td>
                            <td>{studentData.name}</td>
                            <td>{studentData.gender}</td>
                            <td>{studentData.dob}</td>
                            <td>{studentData.school_name}</td>
                            <td>{studentData.preferrd_time}</td>
                            <td>{studentData.term}</td>
                            <td>{studentData.location}</td>
                            <td>{studentData.tutor_level}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <p className="ml-3">No students added</p>
                  )}
                </Card>
                <Row className="mt-4">
                  <Col md="12" className="d-flex align-items-center">
                    <h3>Attendance</h3>
                    <div>
                      <Link
                        to={`/admin/attendance/attendance-profile/${dataList?.tutor_classes?.[0]?.id}/${params?.pid}/1/1#target-section`}
                      >
                        <Button color="primary" className="mr-2">
                          + Add
                        </Button>
                      </Link>
                      <Link
                        to={`/admin/attendance/attendance-profile/${dataList?.tutor_classes?.[0]?.id}/${params?.pid}/1/1#target-section`}
                      >
                        <Button color="info">Download Attendance Report</Button>
                      </Link>
                    </div>
                    {/* <div  style={{width:"200px" }}> */}

                    {/* </div> */}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="6">
                    <Progress
                      className="my-2"
                      value={sessionPercentage}
                      style={{ height: "25px", flex: "1", marginLeft: "10px" }}
                    >
                      {sessionPercentage}
                    </Progress>
                    <Table>
                      <thead>
                        <tr>
                          <th>Class Name</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allAttendance && allAttendance.length > 0 ? (
                          allAttendance.map((item, index) => (
                            <tr key={index}>
                              <td>{dataList?.tutor_classes?.[0]?.name}</td>
                              <td>{item?.attendance_date}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" style={{ textAlign: "center" }}>
                              No attendance found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                  <Col md="6">
                    <Col md="12">
                      <h3>Support & Notes</h3>
                      <Link
                        to={`/admin/supportticket/addticket/${dataList?.mobile}`}
                      >
                        <Button color="primary">+ Add</Button>
                      </Link>
                      <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                        <Table
                          className="align-items-center table-flush mt-1"
                          responsive
                        >
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">S.No.</th>
                              <th scope="col">Added on</th>
                              <th scope="col">Subject</th>
                              <th scope="col">Message</th>
                              <th scope="col">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {supportdata && supportdata.length > 0 ? (
                              supportdata.map((item, index) => (
                                <tr key={index}>
                                  <th scope="col">{index + 1}</th>
                                  <th scope="col">
                                    {moment(item?.updatedAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </th>
                                  <th scope="col">
                                    {item?.subject
                                      ?.split(" ")
                                      .slice(0, 3)
                                      .join(" ") || ""}
                                  </th>
                                  <th scope="col">
                                    {item?.complaint
                                      ?.split(" ")
                                      .slice(0, 3)
                                      .join(" ") || ""}
                                  </th>
                                  <th scope="col">{item?.status}</th>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>

                    <Col md="12">
                      <h3>Leave & Holiday</h3>
                      <Button color="primary" onClick={toggle6}>
                        + Add
                      </Button>
                      <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                        <Table
                          className="align-items-center table-flush mt-1"
                          responsive
                        >
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">S.No.</th>
                              <th scope="col">Added on</th>
                              <th scope="col">Date</th>
                              <th scope="col">Message</th>
                            </tr>
                          </thead>
                          <tbody>
                            {leavedata && leavedata.length > 0 ? (
                              leavedata.map((item, index) => (
                                <tr key={index}>
                                  <th scope="col">{index + 1}</th>
                                  <th scope="col">
                                    {moment(item?.updatedAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </th>
                                  <th scope="col">{item?.date}</th>
                                  <th scope="col">
                                    {item?.Notes?.split(" ")
                                      .slice(0, 3)
                                      .join(" ") || ""}
                                  </th>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row className="mt-4"></Row>
                <Row className="mt-4"></Row>
              </div>
              <div style={getTabContentStyle("Classes")}>
                <CardBody>
                  <Commenction />
                </CardBody>
              </div>
              <div style={getTabContentStyle("Payments")}>
                <Card className="shadow">
                  <CardBody>
                    <CardHeader className="border-0 d-flex justify-content-between ">
                      <h3 className="mb-0">Classes List</h3>
                    </CardHeader>
                    {dataList?.tutor_classes?.length > 0 ? (
                      <Table
                        className="align-items-center table-flush"
                        responsive
                      >
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">Class NAME</th>
                            <th scope="col">Mode</th>
                            <th scope="col">State</th>
                            <th scope="col">City</th>
                            <th scope="col">Location</th>
                            <th scope="col">Badge</th>
                            <th scope="col">Start Date</th>
                            <th scope="col">Start Time</th>
                            <th scope="col">End Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataList.tutor_classes.map(
                            (classData, classIndex) => (
                              <tr key={`${classIndex}classList`}>
                                <td>{classIndex + 1}</td>
                                <td>{classData.name}</td>
                                <td>{classData.mode}</td>
                                <td>{classData.state}</td>
                                <td>{classData.city}</td>
                                <td>{classData.location}</td>
                                <td>{classData.badge}</td>
                                <td>{classData.start_date}</td>
                                <td>{classData.start_time}</td>
                                <td>{classData.end_time}</td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </Table>
                    ) : (
                      <p className="d-flex text-center">No classes found</p>
                    )}
                  </CardBody>
                </Card>
              </div>

              <div style={getTabContentStyle("Finance&invoices")}>
                <CardBody>
                  <Container>
                    <Row className="mt-4">
                      <Col
                        md="12"
                        className="d-flex justify-content-between align-items-center"
                      >
                        <h5>Balance Details</h5>
                        <Button
                          color="info"
                          onClick={() => {
                            Navigate(`/admin/viewinvoice/${params?.id}`);
                          }}
                        >
                          View full history
                        </Button>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col md="4">
                        <p>
                          Unallocated Sessions:{" "}
                          {classData?.number_of_session
                            ? classData?.number_of_session
                            : "0"}
                        </p>
                        <p>
                          Usually pays by:{" "}
                          {creditdata?.lastPayment?.pay_mode || "Not Paid Yet"}
                        </p>
                      </Col>
                      <Col md="4" className="text-center">
                        <p>
                          Available Balance: ₹{"100"}
                          {creditdata?.data
                            ? creditdata.data.price_parent -
                              (creditdata.invoiceData?.invoiceData
                                ?.total_paid ?? 0)
                            : 0}
                          /-
                        </p>
                        <p>
                          Number of Payments:{"10"}
                          {creditdata
                            ? creditdata?.invoiceData?.number_of_payments
                            : "0"}
                        </p>
                      </Col>
                      <Col md="4" className="text-right">
                        <p>
                          Total Paid: ₹{"100"}
                          {creditdata?.invoiceData?.total_paid
                            ? creditdata?.invoiceData?.total_paid
                            : "0"}{" "}
                          /-
                        </p>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col md="12">
                        <Table>
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>invoice no</th>
                              <th>invoice pic</th>
                              <th>Type</th>
                              <th>Credit</th>
                              <th>Debit</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data && data.length > 0 ? (
                              data.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    {moment(item?.updatedAt).format(
                                      "DD-MM-YYYY hh:mm A"
                                    )}
                                  </td>
                                  <td>{item?.invoice_number}</td>
                                  <td>
                                    <img
                                      src={item?.invoicePic?.image}
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        cursor: "pointer",
                                      }}
                                      alt="invoice"
                                      onClick={() =>
                                        window.open(
                                          item?.invoicePic?.image,
                                          "_blank",
                                          "width=600,height=400"
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    <Button color="success">Paid</Button>
                                  </td>
                                  <td>Yes</td>
                                  <td>No</td>
                                  <td>{item?.invoice_amount}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="10"
                                  style={{ textAlign: "center" }}
                                >
                                  No invoice found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col md="12" className="table-responsive">
                        <Table>
                          <thead>
                            <tr>
                              <th>STUDENT'S FEE</th>
                              <th>DATE OF PAYMENT RECEIVED</th>
                              <th>TENURE CHARGED</th>
                              <th>TOTAL FEE CHARGED</th>
                              <th>TOTAL SESSIONS</th>
                              <th>TUTOR SALARY</th>
                              <th>GROSS MARGIN</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                {classData?.price_parent ? (
                                  <>₹{classData.price_parent}</>
                                ) : (
                                  "0"
                                )}
                              </td>
                              <td>{classData.price_parent && "19-Mar-2024"}</td>
                              <td>
                                {classData.price_parent && (
                                  <>
                                    {" "}
                                    <Progress value="25" className="mr-1" />
                                    <Progress value="25" className="mr-1" />
                                    <Progress value="25" className="mr-1" />
                                  </>
                                )}
                              </td>
                              <td>{classData.price_parent && "14,100.00"}</td>
                              <td>
                                {classData?.number_of_session}{" "}
                                {classData?.number_of_session && (
                                  <>Sessions of</>
                                )}{" "}
                                {(() => {
                                  const startTime = classData?.start_time;
                                  const endTime = classData?.end_time;

                                  if (startTime && endTime) {
                                    // Parse the time strings
                                    const [
                                      startHours,
                                      startMinutes,
                                      startSeconds,
                                    ] = startTime.split(":").map(Number);
                                    const [endHours, endMinutes, endSeconds] =
                                      endTime.split(":").map(Number);

                                    // Create Date objects
                                    const start = new Date(
                                      0,
                                      0,
                                      0,
                                      startHours,
                                      startMinutes,
                                      startSeconds
                                    );
                                    const end = new Date(
                                      0,
                                      0,
                                      0,
                                      endHours,
                                      endMinutes,
                                      endSeconds
                                    );

                                    // Calculate the difference in milliseconds
                                    let diff = end - start;

                                    // Handle cases where end time is on the next day
                                    if (diff < 0) {
                                      diff += 24 * 60 * 60 * 1000;
                                    }

                                    // Convert the difference to hours and minutes
                                    const hours = Math.floor(
                                      diff / (1000 * 60 * 60)
                                    );
                                    const minutes = Math.floor(
                                      (diff % (1000 * 60 * 60)) / (1000 * 60)
                                    );

                                    return `${hours} hours ${minutes} min`;
                                  }

                                  return "";
                                })()}
                              </td>
                              <td>
                                {classData?.tutorData?.first_name}{" "}
                                {classData?.tutorData?.last_name}{" "}
                                {classData?.price_tutor}
                                {classData?.price_tutor && "/- ₹"}
                              </td>
                              <td>
                                {classData?.price_parent && "₹"}{" "}
                                {classData?.price_parent -
                                  classData?.price_tutor}{" "}
                                (
                                {(() => {
                                  if (
                                    classData?.price_parent &&
                                    classData?.price_tutor
                                  ) {
                                    const margin =
                                      ((classData.price_parent -
                                        classData.price_tutor) /
                                        classData.price_parent) *
                                      100;
                                    return `${margin.toFixed(2)}%`; // Formats to 2 decimal places
                                  }
                                  return ""; // Fallback for missing data
                                })()}
                                )
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </CardBody>
              </div>
            </div>
            {/* </div> */}
          </div>
        </CardBody>
      </Card>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Add Notes</h4>
        </ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmitNotes}>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Complaint</Label>

                  <Input
                    name="Notes"
                    id="forType"
                    type="textarea"
                    onChange={(e) => setNotes(e.target.value)}
                    value={Notes}
                    placeholder="Enter Complaint"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>

              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
              >
                Save
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
      <Modal isOpen={leaveon} toggle={toggle6}>
        <ModalHeader toggle={toggle6}>
          <h4>Add Leave/Holyday</h4>
        </ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmitLeave}>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Date</Label>
                  <Input name="date" id="forType" type="date"></Input>
                </FormGroup>
                <FormGroup>
                  <Label for="exampleEmail">Message</Label>

                  <Input
                    name="Notes"
                    id="forType"
                    type="textarea"
                    onChange={(e) => setNotes(e.target.value)}
                    value={Notes}
                    placeholder="Enter Complaint"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle6}>
                Cancel
              </Button>

              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
              >
                Save
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default ParentsProfile;
